<template>
  <el-container class="zv-layout">
    <div class="loading" v-if="loading" v-loading.fullscreen.lock="loading"></div>

    <el-header height="44px">
      <top-bar :top-bar-click="topBarClick"></top-bar>
    </el-header>
    <el-container>
      <sidebar :width="sliderWidth"></sidebar>
      <el-container>
        <el-main id="el-main">
          <!-- <div id="nav">
                        <router-link to="/home">Home</router-link> |
                        <router-link to="/">About</router-link>
          </div>-->
          <transition name="fade-transform" mode="out-in">
            <!--   <router-view/>-->
            <!-- <router-view :key="key" /> -->

            <keep-alive>
              <!--使用keep-alive会将页面缓存-->
              <router-view v-if="$route.meta.keepAlive == true" :key="key"></router-view>
            </keep-alive>

            <!--<keep-alive :include="cachedViews">-->
            <!---->
            <!--</keep-alivekeepkeep>-->
          </transition>
          <router-view v-if="$route.meta.keepAlive != true"></router-view>
          <!--<div class="test">test</div>-->
        </el-main>
        <el-footer style="height: 42px;">
          <copy-right></copy-right>
        </el-footer>
      </el-container>
    </el-container>
  </el-container>
</template>

<script>
import pageMixin from "@/mixins/pageMixin";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import tokenService from "@/utils/services/token_service";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import CopyRight from "../../components/CopyRight";
import commonApi from "@/api/commonApi";
import { secLvlMenuData } from '@/config/menuConfig';
import localData from '@/utils/utils/localData';
//import eventBus from "@/utils/services/event_service"
// import httpService from "@/utils/services/http_service";

export default {
  name: "Layout",
  mixins: [pageMixin],
  components: { Sidebar, TopBar, CopyRight },

  data() {
    return {
      loading: false,
      width: 200,
      dataInited: false
    };
  },
  computed: {
    ...mapState({
      hasLogin: state => state.login
    }),
    ...mapState("userInfo", {
      userInfo: state => state
      // username:state=>state.login
    }),
    ...mapGetters(["getMenuCollapse"]),
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.fullPath;
    },
    sliderWidth() {
      let retWidth = 200;
      if (this.getMenuCollapse) {
        retWidth = 56;
      }
      return retWidth;
    }
  },
  methods: {
    ...mapMutations("userInfo", []),
    ...mapMutations("authority", ["SET_AUTHORITY"]),
    ...mapActions(["logout"]),
    ...mapActions("userInfo", ["setUserInfo"]),
    ...mapActions("authority", ["setAuthority"]),
    ...mapActions(["delAllViews"]),

    ...mapActions("menu", ['setMenuCode']),

    toggle(isSidebarOpen) {
      if (isSidebarOpen) {
        this.width = 200;
      } else {
        this.width = 56;
      }
    },
    toUrl(name, params) {
      this.$router.push({
        name: name,
        params: params
      });
    },
    topBarClick(type) {
      let vm = this;
      if (type == "logout") {
        // vm.logout();
        // vm.$store.dispatch("delAllViews");
        commonApi.logout().then(function(res) {
          vm.logout();
          vm.setAuthority({});
          vm.delAllViews();
          // localData.removeLocalAreaList();
        })
      } else if (type == "account") {
        vm.toUrl("usercenter");
      } else if (type == "verify") {
        vm.toUrl("usercenter");
      }
    },
    async fetchData() {
      let vm = this;
      let resData = await commonApi.getMyUserInfo()
      console.log('rrrrrrr')
      console.log(resData)
      vm.setUserInfo(resData.info)
    },
    initMenuCode() {
      console.log('rrrrrrrr')
      console.log(this.$route)
      let that = this
      let path = this.$route.path
      let menuCode = 'dataInput'
      secLvlMenuData.children.forEach(item => {
        if (item.url && item.url == path) {
          menuCode = item.pCode
        }

        if (item.children && item.children.length) {
          item.children.forEach(subItem => {
            if (subItem.url && subItem.url == path) {
              menuCode = item.pCode
            }
          })
        }
      })
      this.setMenuCode(menuCode);
    }
  },

  async created() {
    let _token = tokenService.getToken();
    if (!_token) {
      window.console.log("no token");
      this.$router.push({
        name: "login"
      });
    } else {
      await this.fetchData()
      this.dataInited = true
    }
  },

  mounted() {
    this.initMenuCode()
  }
};
</script>

<style lang="scss">
.test {
  background-color: $bg;
}
</style>

<style lang="less" scoped>
@import "../../static/less/theme.less";

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  #nav {
    padding: 30px;
    a {
      font-weight: bold;
      color: #2c3e50;
      &.router-link-exact-active {
        color: @zvBlue;
      }
    }
  }

  .el-container {
    width: 100%;
  }

  .el-footer {
    padding: 0;
    // background-color: #fff;
    color: #333;
    text-align: center;
    line-height: 42px;
  }
  .el-header {
    padding: 0;
    color: #333;
    z-index: 999;
    // background-color: @zvBlue;
    background-color: #121416;
    //box-shadow: 0px 3px 10px 0px rgba(33, 33, 33, 0.08);
  }
  .el-footer {
    // background-color: #eee;
    background-color: #f0f0f0;
    border-top: solid 1px #ddd;
  }

  .el-main {
    flex-basis: calc(100vh - 150px);
    padding: 0;
    background-color: #f2f2f2;
    color: #333;
  }

  & > .el-container {
    margin-bottom: 0;
    height: 100vh;
  }
}
</style>
